import React from "react";

import { Form, InputNumber } from "antd";
interface props {
  placeholder?: string;
  name: string;
  validation: {
    required: boolean;
    message?: string;
  }[];
}

const SingleInput: React.FC<props> = (props) => {
  const { placeholder, name, validation } = props;
  return (
    <div className="answer-input-wrapper">
      <Form.Item
        name={name}
        rules={validation}
        className="answer-input-wrapper__number-input"
      >
        <InputNumber placeholder={placeholder} />
      </Form.Item>
    </div>
  );
};

export default SingleInput;
